"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var actionsRegistry_1 = require("./actionsRegistry");
function clearRegistry() {
    actionsRegistry_1.default.clear();
}
exports.clearRegistry = clearRegistry;
function createAction(type, paramsCreator) {
    if (paramsCreator === void 0) { paramsCreator = function () { return ({}); }; }
    if (actionsRegistry_1.default.has(type)) {
        throw "Duplicate action " + type;
    }
    else {
        actionsRegistry_1.default.add(type);
    }
    var actionCreator = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var params = paramsCreator.apply(void 0, args);
        if ('type' in params) {
            console.warn('Property type is reserved by action');
        }
        return Object.assign(params, { type: type });
    };
    actionCreator.toString = function () { return type; };
    actionCreator.valueOf = function () { return type + ","; };
    return actionCreator;
}
exports.default = createAction;



//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-actions-helpers/lib/createAction.js
// module id = ./node_modules/redux-actions-helpers/lib/createAction.js
// module chunks = 0